import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getPartsList",
      "getPartsListCounter",
      "getResourcesList",
      "getResourcesListCounter",
      "getInventoryList",
      "getInventoryListCounter"
    ])
  },
  mixins: [announcements],
  methods: {
    changeOrderListItemStatus(status, item, order) {
      let newList = [];
      let tag = item.basic.tag;
      let list = null;
      // CHECK
      if (tag === "L5") {
        list = this.getPartsList;
      }
      if (tag === "H5") {
        list = this.getResourcesList;
      }
      // MODIFY
      if (list !== null) {
        for (let i = 0; i < list.length; i++) {
          if (item.basic.idi !== list[i].basic.idi) {
            newList.push(list[i]);
          } else {
            list[i].char.status = status;
            list[i].char.oidg = order.basic.idg;
            list[i].char.odid = order.basic.did;
            list[i].char.oid = order.basic.id;
            list[i].char.ot = order.basic.title;
            newList.push(list[i]);
          }
        }
      }
      // UPDATE STORE
      if (tag === "L5") {
        this.$store.dispatch("changePartsList", newList);
        // refesh counters
        let store = "changePartsListCounter";
        this.$store.dispatch(store, this.getPartsListCounter + 1);
        this.$store.dispatch(store, this.getPartsListCounter - 1);
      }
      if (tag === "H5") {
        this.$store.dispatch("changeResourcesList", newList);
        // refesh counters
        let store = "changeResourcesListCounter";
        this.$store.dispatch(store, this.getResourcesListCounter + 1);
        this.$store.dispatch(store, this.getResourcesListCounter - 1);
      }
      // NOTIFY CHANGE
      this.$store.dispatch("changeDataSavePendingIndication", true);
    },
    changeOrderListItemMaterialOnOrderCounter(qty, item) {
      let newList = [];
      let list = this.getInventoryList;
      // MODIFY
      if (list !== null) {
        for (let i = 0; i < list.length; i++) {
          if (item.basic.idi !== list[i].basic.idi) {
            newList.push(list[i]);
          } else {
            // eslint-disable-next-line
            list[i].char.stoord = parseInt(qty) + parseInt(list[i].char.stoord);
            newList.push(list[i]);
          }
        }
      }

      this.$store.dispatch("changeInventoryList", newList);
      // refesh counters
      let store = "changeInventoryListCounter";
      this.$store.dispatch(store, this.getInventoryListCounter + 1);
      this.$store.dispatch(store, this.getInventoryListCounter - 1);
      // NOTIFY CHANGE
      this.$store.dispatch("changeDataSavePendingIndication", true);
    }
  }
};
